module.exports = __webpack_public_path__ + "static/img/b10.4ab6c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b10.png
// module id = vtOD
// module chunks = 1